import { Collapse, Tabs } from "@mantine/core";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import Page from "../../components/Page";
import Item from "./item";
import "./styles.css";

const Index = ({ t }) => {
  const faq1 = [
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
    {
      que: "What makes faces2hire unique and different?",
      ans: "We’re FREE for both Job Seekers and Employers. We help Job Seekers stand out, to Get Noticed and Get Hired by giving them the tools to enhance their skills, experience and unique qualities. We help Employers save time and money by posting unlimited jobs for FREE; they have the ability to identify, screen, store, and manage resumes at no cost with our Applicant Tracking System (ATS) software.",
    },
  ];
  return (
    <Page className="landing-page">
      <div className="faqs">
        <h2 className="text-dark text-center mb-5">
          Frequently Asked Questions
        </h2>
        <Tabs defaultValue="1" orientation="vertical">
          <Tabs.List>
            <Tabs.Tab value="1">Common FAQs</Tabs.Tab>
            <Tabs.Tab value="2">FAQs For Job Seekers</Tabs.Tab>
            <Tabs.Tab value="3">Job Search</Tabs.Tab>
            <Tabs.Tab value="4">Apply for Jobs</Tabs.Tab>
            <Tabs.Tab value="5">Resume</Tabs.Tab>
            <Tabs.Tab value="6">FAQs for Employers</Tabs.Tab>
            <Tabs.Tab value="7">Job Posting</Tabs.Tab>
            <Tabs.Tab value="8">Candidate Search</Tabs.Tab>
            <Tabs.Tab value="9">Contacting Candidate</Tabs.Tab>
            <Tabs.Tab value="10">Stealth</Tabs.Tab>
          </Tabs.List>
          <div className="panels">
            <Tabs.Panel value="1">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="2">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="3">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="4">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="5">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="6">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="7">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="8">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="9">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
            <Tabs.Panel value="10">
              {faq1.map((obj, key) => (
                <Item key={key} que={obj.que} ans={obj.ans} />
              ))}
            </Tabs.Panel>
          </div>
        </Tabs>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
